<script setup lang="ts">
/**
 * Aurora glow — slow-morphing color fields. Calm and premium; the fields
 * blend the theme accent with the foreground tone for depth.
 */
</script>

<template>
  <div
    class="site-hero-anim"
    aria-hidden="true"
  >
    <div
      class="site-anim-aurora h-3/4 w-3/4 -top-1/4 -left-1/6"
      style="background: var(--site-accent); --dur: 19s"
    />
    <div
      class="site-anim-aurora h-2/3 w-2/3 top-1/4 -right-1/6"
      style="background: color-mix(in oklab, var(--site-accent) 55%, var(--site-fg)); --dur: 24s; animation-delay: -8s"
    />
    <div
      class="site-anim-aurora h-1/2 w-1/2 -bottom-1/4 left-1/4"
      style="background: color-mix(in oklab, var(--site-accent) 70%, var(--site-bg)); --dur: 16s; animation-delay: -4s"
    />
  </div>
</template>
